import { createFileRoute } from "@tanstack/react-router";
import { VendorAboPage } from "@/components/vendor/abo/VendorAboPage";

export const Route = createFileRoute("/vendor/abo")({
  head: () => ({ meta: [{ title: "Abo verwalten · Venue Portal" }] }),
  component: VendorAboRoute,
});

function VendorAboRoute() {
  return <VendorAboPage />;
}
